/*
Script initials (Imperial Script, one letter) are added at runtime so the
content stays plain in the Ghost editor: article headings, post-list titles
and blockquotes get their first letter wrapped in <span class="initial">.
Headings that do not start with a letter are left alone.
*/

function isLetter(ch) {
    return ch.toLowerCase() !== ch.toUpperCase();
}

// First text node carrying something other than whitespace
function firstTextNode(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
            return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        },
    });
    return walker.nextNode();
}

export function wrapInitial(el, wrapRest) {
    // Already done? (initials inside a wordmark span do not count)
    if (!el || Array.from(el.querySelectorAll('.initial')).some((i) => !i.closest('.name'))) {
        return false;
    }

    const node = firstTextNode(el);
    if (!node) {
        return false;
    }

    const offset = node.nodeValue.search(/\S/);
    if (offset < 0 || !isLetter(node.nodeValue.charAt(offset))) {
        return false;
    }

    // Split the text node so the first letter can live in its own span
    const rest = node.splitText(offset);
    const letter = rest.nodeValue.charAt(0);
    rest.nodeValue = rest.nodeValue.slice(1);

    const initial = document.createElement('span');
    initial.className = 'initial';
    initial.textContent = letter;
    rest.parentNode.insertBefore(initial, rest);

    // Titles underline the text only, never the script initial
    if (wrapRest) {
        const text = document.createElement('span');
        text.className = 't';
        let next = initial.nextSibling;
        while (next) {
            const following = next.nextSibling;
            text.appendChild(next);
            next = following;
        }
        initial.parentNode.appendChild(text);
    }

    return true;
}

// A trailing "— Name" becomes a drawn blue rule followed by a roman cite
const ATTRIBUTION = /\s*(?:—|–|-)\s*(?:<(?:strong|em)>)?\s*([^<]{2,80}?)\s*(?:<\/(?:strong|em)>)?\s*((?:<\/p>\s*)?)$/;

function formatQuote(quote) {
    if (!quote.querySelector('cite')) {
        const html = quote.innerHTML;
        const match = html.match(ATTRIBUTION);

        if (match) {
            quote.innerHTML =
                html.slice(0, match.index).replace(/\s+$/, '') +
                '<span class="rule"></span><cite>' +
                match[1].trim() +
                '</cite>' +
                match[2];
        }
    }

    wrapInitial(quote, false);
}

// "Jean-Baptiste" inside a heading is set like the wordmark: script J and B.
// Returns true when the wordmark opens the heading — it then already carries the
// script initial, so wrapInitial() must not wrap a second one inside it.
const NAME = /Jean-Baptiste/;

function markName(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
        const match = node.nodeValue.match(NAME);
        if (!match || node.parentElement.closest('.name')) {
            continue;
        }
        const before = node.nodeValue.slice(0, match.index);
        const after = node.nodeValue.slice(match.index + match[0].length);
        const span = document.createElement('span');
        span.className = 'name';
        span.innerHTML = '<span class="initial">J</span>ean-<span class="initial b">B</span>aptiste';
        const parent = node.parentNode;
        parent.insertBefore(document.createTextNode(before), node);
        parent.insertBefore(span, node);
        node.nodeValue = after;
        break;
    }

    // Also covers a re-run, where the wordmark is already in place
    const first = firstTextNode(el);
    return Boolean(first && first.parentElement.closest('.name'));
}

// Post-list rows appended by the infinite scroll need the same treatment
export function initialsIn(root) {
    root.querySelectorAll('.post-item-title').forEach((title) => wrapInitial(title, true));
}

export default function initials() {
    document
        .querySelectorAll('.gh-content h2, .gh-content h3, .gh-content h4, .gh-content h5, .gh-content h6')
        .forEach((heading) => wrapInitial(heading, false));

    document.querySelectorAll('.gh-content blockquote').forEach(formatQuote);

    document.querySelectorAll('.gh-readmore h4, .gh-page-head h1').forEach((title) => wrapInitial(title, true));

    // Article and page titles carry the initial too (no underline span needed)
    document.querySelectorAll('.gh-title').forEach((title) => wrapInitial(title, false));

    // Home heading: script initial, and "Jean-Baptiste" set like the wordmark.
    // A heading that opens on the wordmark already starts with a script letter.
    document.querySelectorAll('.gh-home-heading').forEach((heading) => {
        if (!markName(heading)) {
            wrapInitial(heading, false);
        }
    });

    initialsIn(document);
}
